import { Button } from "@/components/ui/button";
import { Save, X, Loader2 } from "lucide-react";
interface CardPanelHeaderProps {
  title: string;
  description: string;
  tag?: string;
  onClose: () => void;
  onSave: () => void;
  saveStatus: "idle" | "saving" | "saved";
  disabled?: boolean;
  saveDisabled?: boolean;
}

export function CardPanelHeader({
  title,
  description,
  tag,
  onClose,
  onSave,
  saveStatus,
  disabled,
  saveDisabled,
}: CardPanelHeaderProps) {
  return (
    <div className="rounded-[32px] border border-slate-200/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.96)_0%,rgba(248,250,252,0.92)_100%)] p-6 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="min-w-0 flex-1">
          {tag && (
            <div className="inline-flex items-center rounded-full border border-primary/15 bg-primary/[0.08] px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-primary">
              {tag}
            </div>
          )}
          <h2 className="mt-4 text-3xl font-bold leading-tight text-slate-900">{title}</h2>
          <p className="mt-2 max-w-3xl text-base font-normal leading-6 text-slate-500">{description}</p>
        </div>
        <div className="flex flex-shrink-0 items-center gap-3">
          <Button
            size="sm"
            onClick={onSave}
            disabled={saveStatus === "saving" || disabled || saveDisabled}
            className="h-11 rounded-2xl bg-primary px-5 text-sm font-semibold text-white shadow-none hover:bg-primary/80"
          >
            {saveStatus === "saving" ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" /> {"Saving..."}
              </>
            ) : saveStatus === "saved" ? (
              <>
                <Save className="mr-2 h-4 w-4" /> {"Saved"}
              </>
            ) : (
              <>
                <Save className="mr-2 h-4 w-4" /> {"Save Draft"}
              </>
            )}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="h-11 w-11 rounded-2xl border border-slate-200 bg-white text-slate-400 hover:bg-slate-50 hover:text-slate-500"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
